<template>
  <v2-dropdown
    v-if="fullCurrencyList.length"
    class="v2-currency-dropdown"
    :options="fullCurrencyList"
    :value="selectedCurrencyValue"
    :searchable="true"
    empty-text="Nothing was found. Try another currency."
    @select="onSelectCurrency"
  >
    <template #toggle="{ isOpen }">
      <button
        class="v2-currency-dropdown__toggle"
        :class="{ 'v2-currency-dropdown__toggle--open': isOpen }"
        type="button"
      >
        <span class="v2-currency-dropdown__label">
          <span class="v2-currency-dropdown__label-prefix">Currency:</span>
          {{ selectedCurrencyValue }}
        </span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="v2-currency-dropdown__chevron"
          :class="{ 'v2-currency-dropdown__chevron--open': isOpen }"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
    </template>
  </v2-dropdown>
</template>

<script>
import V2Dropdown from '@/components/v2/V2Dropdown.vue'

export default {
  name: 'V2CurrencyDropdown',
  components: { V2Dropdown },
  props: {
    baseCurrency: {
      type: String,
      default: '',
    },
    currencies: {
      type: Array,
      default: () => [],
    },
    selectedCurrency: {
      type: String,
      default: '',
    },
  },
  emits: ['on-selected-currency'],
  computed: {
    fullCurrencyList() {
      const unique = new Set([this.baseCurrency, ...this.currencies].filter(Boolean))
      return Array.from(unique)
    },
    selectedCurrencyValue() {
      return this.selectedCurrency || this.baseCurrency || ''
    },
  },
  methods: {
    onSelectCurrency(name) {
      if (name === this.baseCurrency) {
        this.$emit('on-selected-currency', '')
        return
      }
      this.$emit('on-selected-currency', name)
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-currency-dropdown {
  width: 170px;

  // Clean opaque-white toggle — replaced the recessed-pocket glass recipe.
  &__toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 38px;
    padding: var(--v2-space-2) var(--v2-space-3);
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;
    color: var(--v2-foreground);
    // Trigger — translucent fill, no `backdrop-filter` (substrate-blur recipe).
    background: var(--v2-glass-surface-2);
    border: 1px solid var(--v2-glass-stroke);
    border-radius: var(--v2-radius-md);
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover:not(.v2-currency-dropdown__toggle--open) {
      border-color: var(--v2-glass-stroke-strong);
    }

    &--open {
      border-color: var(--v2-primary);
      box-shadow: 0 0 0 3px oklch(0.62 0.21 295 / 0.25);
    }
  }

  &__label {
    display: inline-flex;
    align-items: baseline;
    gap: var(--v2-space-1);
    font-weight: 500;
    color: var(--v2-foreground);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__label-prefix {
    color: var(--v2-muted-foreground);
    font-weight: 400;
  }

  &__chevron {
    flex-shrink: 0;
    color: var(--v2-muted-foreground);
    transition: transform 0.2s ease;

    &--open {
      transform: rotate(180deg);
    }
  }
}
</style>
